'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export const useIsIdle = () => {
  const $ = _c(2);
  const [isIdle, setIsIdle] = useState(true);
  const isClient = typeof window !== "undefined";
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const onDidAnything = () => {
        setIsIdle(false);
        window.removeEventListener("mousemove", onDidAnything);
        window.removeEventListener("keydown", onDidAnything);
        window.removeEventListener("click", onDidAnything);
        window.removeEventListener("scroll", onDidAnything);
      };
      if (typeof window !== "undefined") {
        window.addEventListener("mousemove", onDidAnything);
        window.addEventListener("keydown", onDidAnything);
        window.addEventListener("click", onDidAnything);
        window.addEventListener("scroll", onDidAnything);
      }
      return () => {
        if (typeof window !== "undefined") {
          window.removeEventListener("mousemove", onDidAnything);
          window.removeEventListener("keydown", onDidAnything);
          window.removeEventListener("click", onDidAnything);
          window.removeEventListener("scroll", onDidAnything);
        }
      };
    };
    t1 = [isClient];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isIdle;
};